import React from 'react';
import PropTypes from "prop-types";
import { GoogleMapContext } from "../GoogleMap";
import { createLatLngBounds, createLatLng, turnOnAutoBounds} from "../../google"; 

const pointPropType = PropTypes.shape({
    latitude: PropTypes.number.isRequired,
    longitude: PropTypes.number.isRequired,
});

export default class MapBounds extends React.Component {
  static propTypes = {
    points: PropTypes.arrayOf(pointPropType).isRequired,
    padding: PropTypes.shape({
      bottom: PropTypes.number.isRequired,
      left: PropTypes.number.isRequired,
      right: PropTypes.number.isRequired,
      top: PropTypes.number.isRequired,
    }),
    autoMapFocus: PropTypes.bool.isRequired,
  } 
  
  static contextType = GoogleMapContext;

  fitMaptoBounds(points) {
    points.forEach((point) => {
      this.bounds.extend(createLatLng(point.latitude, point.longitude));
    });
    this.context.fitBounds(this.bounds, this.props.padding);
    turnOnAutoBounds(this.bounds, this.props.padding, this.context);
  }

  componentDidMount() {
    this.bounds = createLatLngBounds();
    this.fitMaptoBounds(this.props.points);
  }

  componentWillReceiveProps(nextProps) {
    this.bounds = createLatLngBounds();
    if (nextProps.autoMapFocus) {
      this.fitMaptoBounds(nextProps.points);
    }
  }

  render() {
    return null;
  }
}
